import { Col } from 'antd';
import React from 'react';
import { reportSortOptions } from './ReportSortOptions';
import { ReportComponentTypeFilter, SearchFilter, SearchFilterContainer, SortByFilter } from '../filters';
export const ReportSearch = ({ onChange, queryParams }) => {
    var _a;
    return React.createElement(SearchFilterContainer, null,
        React.createElement(Col, { span: 12 },
            React.createElement(SearchFilter, { onChange: onChange })),
        React.createElement(Col, { span: 12 }),
        React.createElement(Col, { span: 12 },
            React.createElement(ReportComponentTypeFilter, { onChange: onChange, selected: (_a = queryParams.componentTypes) !== null && _a !== void 0 ? _a : [] })),
        React.createElement(Col, { className: 'align-right', span: 12 },
            React.createElement(SortByFilter, { defaultSortOption: reportSortOptions[0], onChange: onChange, options: reportSortOptions, queryParams: queryParams })));
};
